const escapeHtml = (value) =>
    String(value ?? "").replace(
        /[&<>"']/g,
        (char) =>
            ({
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#39;",
            }[char])
    );

export const buildTransferReceiptHtml = (receipt, t, direction = "ltr") => {
    const label = (key) => escapeHtml(t(`stockTransfer.${key}`));
    const value = (text) => `<bdi dir="auto">${escapeHtml(text)}</bdi>`;
    return `<!doctype html><html dir="${
        direction === "rtl" ? "rtl" : "ltr"
    }"><head><meta charset="utf-8"/>
<title>${label("transferReceipt")}</title><style>
*{box-sizing:border-box}
html{margin:0;padding:0;height:auto}
body{font:12px/1.35 Arial,sans-serif;color:#111;background:#fff;margin:0 auto;padding:2mm;width:72mm;max-width:100%;height:auto;overflow-wrap:anywhere}
h1{font-size:16px;margin:0 0 3mm}p,.route{margin:2mm 0}
table{width:100%;table-layout:fixed;border-collapse:collapse;margin-top:3mm}
th,td{border-bottom:1px solid #aaa;padding:2mm 1mm;text-align:start;vertical-align:top;overflow-wrap:anywhere}
th:last-child,td:last-child{width:24%}th{background:#eee}
@page{size:auto;margin:2mm}
@media print{html,body{height:auto;min-height:0;overflow:visible}body{margin:0 auto;padding:0}thead{display:table-row-group}tr,td{break-inside:auto}}
</style></head><body><h1>${label("transferReceipt")}</h1>
<p>${label("postingDate")}: <bdi dir="ltr">${escapeHtml(receipt.posting_date)} ${escapeHtml(receipt.posting_time)}</bdi></p>
<p>${label("transferredBy")}: ${value(receipt.initiated_by)}</p>
<div class="route"><strong>${label("fromCompany")}</strong>: ${value(
        receipt.source_company
    )} — ${value(receipt.source_warehouse)}<br/>
<strong>${label("toCompany")}</strong>: ${value(
        receipt.target_company
    )} — ${value(receipt.target_warehouse)}</div>
<p>${label("deliveryNote")}: ${value(receipt.delivery_note)}<br/>${label(
        "purchaseReceipt"
    )}: ${value(receipt.purchase_receipt)}</p>
<table><thead><tr><th>${label("item")}</th><th>${label(
        "quantity"
    )}</th></tr></thead><tbody>
${(receipt.items || [])
    .map(
        (item) =>
            `<tr><td>${value(item.item_code)}<br/>${value(
                item.item_name
            )}</td><td><bdi dir="ltr">${escapeHtml(item.qty)} ${escapeHtml(
                item.stock_uom
            )}</bdi></td></tr>`
    )
    .join("")}
</tbody></table></body></html>`;
};
